import i18next from 'i18next';
import deTranslations from './lang/de.json';
import enTranslations from './lang/en.json';
import esTranslations from './lang/es.json';

export const i18nInit = async (language: string) => {
  await i18next.init({
    fallbackLng: 'de',
    lng: language,
    resources: {
      de: { translation: deTranslations },
      en: { translation: enTranslations },
      es: { translation: esTranslations },
    },
  });
};

export default i18next;
